<template>
  <div>
    <div class="custom-main">
      <div class="doc-name">
        <div class="til">医生名称：</div>
        <div class="text">{{ resultData.DOC_NAME }}</div>
      </div>
      <div class="check-time">
        <div class="til">检查时间：</div>
        <div class="text">{{ resultData.CHECK_TIME }}</div>
      </div>
      <div class="check-name">
        <div class="til">检查项目：</div>
        <div class="text">{{ resultData.CHECK_NAME }}</div>
      </div>
      <div class="conclusion">
        <div class="til">检查结果：</div>
        <div class="text">{{ resultData.CONCLUSION }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resultData: {},
      empty: false
    }
  },
  mounted() {
    this.resultData = this.$route.params.item
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.custom-main {
  width: 100vw;
  height: 100vh;
  background: rgb(242, 248, 253);
}
.custom-main > div {
  background: #fff;
  padding: 10px;
  margin: 2px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  .til {
    color: #666;
  }
  .text {
    flex: 1;
  }
}

.custom-empty {
  height: calc(100vh - 85px);
  overflow-y: auto;
}

.van-empty__image {
  width: 160px;
  height: 160px;
}

.van-empty__description {
  font-size: 18px;
}
</style>
